import create from 'zustand';

import { AutoRejectEstimation } from '../../../../@types/orderbook';

export enum ModalNames {
  ARA_ARB_ESTIMATION = 'ARA_ARB_ESTIMATION',
}

interface AraArbData {
  symbol: string;
  data: AutoRejectEstimation[];
}

type ModalData = AraArbData | undefined;

interface ModalState {
  activeModal: ModalNames | null;
  modalData: ModalData;
  openModal: (modalName: ModalNames, modalData: ModalData) => void;
  closeModal: () => void;
}

const useDatafeedModalStore = create<ModalState>((set) => ({
  activeModal: null,
  modalData: undefined,
  openModal: (modalName, modalData) => set({ activeModal: modalName, modalData }),
  closeModal: () => set({ activeModal: null, modalData: undefined }),
}));

export default useDatafeedModalStore;
